import WorkerApiService from "../../workerApiServices";

class TipoDreCompetenciaService extends WorkerApiService {

    constructor() {
        super('/api/tipoDreCompetencia')
    }

    search() {
        return this.get("/search")
    }

    save(object){
        return this.post("/save", object)
    }

    update(object){
        return this.put("/update", object)
    }

    delete(object){
        return this.post("/delete", object)
    }

}

export default TipoDreCompetenciaService